import Blocks from "../../assets/imgProducts/building-blocks.png";
import Joystick from "../../assets/imgProducts/joystick.png";
import Cell from "../../assets/imgProducts/cell-phone.png";
import Tv from "../../assets/imgProducts/tv.png";

import Refrigerator from "../../assets/imgProducts/refrigerator.png";
import Machine from "../../assets/imgProducts/washing-machine.png";
import Notebook from "../../assets/imgProducts/notebook.png";
import Tablet from "../../assets/imgProducts/tablet.png";
import Vinho from "../../assets/zkp/vinho.svg";
import ArrowRight from "../../assets/arrow-right.svg";

import ArrowLeft from "../../assets/arrow-left.svg";
import { CardProduct } from "../CardProduct";
import { ProductsCarouselContainer } from "./style";

const products = [
  process.env.REACT_APP_ZKP === "true"
    ? {
        id: 1,
        name: "Vinho Tinto Suave 750ml Uvas Campestres",
        price: 150.0,
        img: Vinho,
        productCode: "Cód: 00000000000  - Uvas Campestres",
      }
    : {
        id: 1,
        name: "Televisão OLED Super Digital 42”",
        price: 2099.0,
        img: Tv,
        productCode: "Cód: 00000000000  - Super Digital",
      },
  {
    id: 2,
    name: "Smartphone 512GB 5G Orange - Cinza Metálico",
    price: 8099.0,
    img: Cell,
  },
  {
    id: 3,
    name: "Video Game Metaverso 2 em 1",
    price: 2399.0,
    img: Joystick,
  },
  {
    id: 4,
    name: "Blocos de montar Bricks - Cores sortidas",
    price: 1999.0,
    img: Blocks,
  },
];

const productsFooter = [
  {
    id: 5,
    name: "Refrigerador Duplex Refrinox - Inox",
    price: 3999.0,
    img: Refrigerator,
  },
  {
    id: 6,
    name: "Tablet 256GB - 5G  Smartfold",
    price: 4999.0,
    img: Tablet,
  },
  {
    id: 7,
    name: "Notebook 500GB SSD Orange - Cinza Metálico",
    price: 10099.0,
    img: Notebook,
  },
  {
    id: 8,
    name: "Máquina de Lavar Roupas LavaTudo - Inox",
    price: 2399.0,
    img: Machine,
    productCode: "Cód: 00000000000  - LavaTudo",
  },
];

export function CarouselPrimary() {
  return (
    <ProductsCarouselContainer>
      <img src={ArrowLeft} alt="" className="arrowLeft" />
      {products.map((product) => (
        <CardProduct key={product.id} {...product} />
      ))}
      <img src={ArrowRight} alt="" className="arrowRight" />
    </ProductsCarouselContainer>
  );
}

export function CarouselSecundary() {
  return (
    <ProductsCarouselContainer>
      <img src={ArrowLeft} alt="" className="arrowLeft" />
      {productsFooter.map((product) => (
        <CardProduct key={product.id} {...product} />
      ))}
      <img src={ArrowRight} alt="" className="arrowRight" />
    </ProductsCarouselContainer>
  );
}
